<template>
  <div class="module">
    <div class="module__title"></div>
    <div class="module__content">
      <div class="gift-box">
        <div
          v-for="(item, key) in giftData.list"
          :key="key"
          class="gift-item"
        >
          <div class="image">
            <img :src="getGiftImg(item.icon)" />
          </div>
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
      <div class="bottom">
        <div class="reward-btn" @click="openBindDialog"></div>
        <div class="tips">仅限官网安卓、iOS下载用户领取</div>
      </div>
      <div class="character"></div>
    </div>
    <bind-dialog :visible.sync="bindDialogVisible" :prizeList="giftLog" type="down" />
  </div>
</template>

<script>
import downloadMixins from '@/mixins/home/downloadMixins'

import BindDialog from '@/views/mobile/components/bindDialog/Index.vue'

export default {
  name: 'MobileHomeDownload',
  mixins: [downloadMixins],
  components: {
    BindDialog,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/pc/btns.scss';

.module {
  height: 171.2vw;

  &__title {
    background-position: center -46.4vw;
  }

  &__content {
    width: 100%;
    height: 117.6vw;
  }
}

.gift-box {
  position: absolute;
  z-index: 1;
  top: 88.266666vw;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-evenly;
  margin: 0 auto;
  width: 89.866666vw;
  height: 39.066666vw;
  background: url('~@/assets/img/mobile/download_gift_box.png') no-repeat;
  background-size: 100%;
}

.gift-item {
  display: flex;
  flex-direction: column;
  margin-top: 6.4vw;
  width: 22.666666vw;

  .image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22.666666vw;
    height: 20.533333vw;
    background: url('~@/assets/img/pc/prize_bg2.png') no-repeat;
    background-size: 100%;

    img {
      width: 13.333333vw;
      height: 13.333333vw;
    }
  }

  .name {
    margin-top: 1.333333vw;
    width: 100%;
    text-align: center;
    color: #584c45;
    font-size: 2.666666vw;
  }
}

.bottom {
  position: absolute;
  bottom: 24.266666vw;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;

  .tips {
    margin-top: 1.333333vw;
    font-size: 2.133333vw;
    color: #584c45;
  }
}

.reward-btn {
  width: 52.133333vw;
  height: 12.8vw;
  background: url('~@/assets/img/mobile/download_gift_btn1.png') no-repeat;
  background-size: 100%;
  cursor: pointer;
}

.character {
  position: absolute;
  top: 34.533333vw;
  width: 100vw;
  height: 65.6vw;
  background: url('~@/assets/img/mobile/character1.png') no-repeat;
  background-size: 100%;
}
</style>